import React, { type ReactElement } from 'react';

import type { SvgProps } from './types';

import * as styles from './Icons.css';

const EmailIcon = ({
  width = '18px',
  height = '12px',
  weight = 'regular',
  viewbox = '0 0 18 12',
}: SvgProps): ReactElement => {
  const className = weight === 'regular' ? styles.regular : styles.weak;

  return (
    <svg width={width} height={height} viewBox={viewbox} version="1.1">
      <title>Email icon</title>
      <g
        id="Email_icon"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      >
        <path d="M17,1 L17,11 L1,11 L1,1 L17,1 Z" strokeWidth="2" />
        <polyline strokeWidth="2" points="2 2 9.13842578 7 16 2" />
      </g>
    </svg>
  );
};

export default EmailIcon;
